module.exports = __webpack_public_path__ + "static/img/Data-Science-is-Different-From-Data-Analytics.f445aac0.jpg";